module.exports = __webpack_public_path__ + "static/media/logo_lmc_h@2x.cf24f408.png";